import React from 'react';
import { Link } from 'react-router-dom';
import { productsList } from '../../data/siteContent';
import './Products.css';

/**
 * Section Nos Produits - Solutions editees par WOTE
 */
function Products({ showViewAll = false, limit }) {
  const products = limit ? productsList.slice(0, limit) : productsList;

  return (
    <section className="products-section" id="produits">
      <div className="container">
        <div className="products-header">
          <h2 className="products-title">Nos Produits</h2>
          <p className="products-subtitle">
            Des solutions conçues par WOTE pour répondre à des besoins concrets du quotidien
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <article key={product.id} className="product-card">
              <div className="product-card-image">
                <img src={product.image} alt={product.name} />
                <span className="product-status">{product.status}</span>
              </div>
              <div className="product-card-body">
                <span className="product-category">{product.category}</span>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-tagline">{product.tagline}</p>
                <p className="product-description">{product.description}</p>
                <a
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="product-link-btn"
                >
                  Découvrir le produit
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M17 7H7M17 7v10" />
                  </svg>
                </a>
              </div>
            </article>
          ))}
        </div>

        {showViewAll && (
          <div className="products-cta">
            <Link to="/produits" className="view-all-products-btn">
              Voir tous nos produits
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}

export default Products;
